import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.png";
import Work5 from "../../assets/work5.png";
import Work6 from "../../assets/work6.png";

export const projectsData = [

    {
        id: 1,
        image: Work5,
        tittle: "Capstone Project: FavX",
        description: "FavX is a React Native mobile app that allows people to exchange favours, developed as a capstone project for the Computer Programming and Analysis program at George Brown College.",
    category: "school",
        url: "https://github.com//xpydr/FavX"
    },

    {
        id: 2,
        image: Work4,
        tittle: "Little Lemon Restaurant",
        description: "Capstone project for the Meta Front-End Developer Professional Certificate, built with React.",
    category: "personal",
        url: "https://github.com/MattGaviria/little-lemmon"
    },


    {
        id: 3,
        image: Work6,
        tittle: "DBZ API",
        description: "Full-stack practice project using React + Vite and Node + Express, focused on API consumption, filtering, and dynamic data rendering.",
        category: "personal",
        url: "https://github.com/MattGaviria/dragonballAPI"
    }, 




    {
        id: 4,
        image: Work1,
        tittle: "Project Managment Tool",
        description: "Project Management SPA built with ASP.Net core, PostgreSQL and Bootsrap.",
        category: "school",
        url: "https://github.com/MattGaviria/PM-Tool"
    }, 


    
    {
        id: 5,
        image: Work2,
        tittle: "Python Game",
        description: "This Python console RPG game was built for an open-source class project, with a focus on collaboration, feature development, and use of version control.",
        category: "school",
        url: "https://github.com/Ginageegee/Comp2152_assignments/tree/main/termproject"

    },


    {
        id: 6,
        image: Work3,
        tittle: "Inventory Management System",
        description: "Inventory SPA built with ASP.Net core, PostgreSQL and Bootsrap.",
        category: "school",
        url: "https://github.com/MattGaviria/invmanager"
    },



];

export const projectsNav = [
    {
        name: "all"
    },
    {
        name: "School"
    },
    {
        name: "Personal"
    }

    
]